import React from "react";
import ReactDOM from "react-dom/client";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style/flexboxgrid.min.css";
import "./style/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
    authority: "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_O898p4hR1",
    client_id: "2oo3ap1pf1kp3h4vghqt01boks",
    redirect_uri: "http://localhost:3000",
    response_type: "code",
    scope: "email openid phone",
};

const container = document.getElementById("root");

if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
        <BrowserRouter>
            <AuthProvider {...cognitoAuthConfig}>
                <App />
            </AuthProvider>
        </BrowserRouter>
    );
} else {
    console.error("Root element not found. Ensure there is a <div id='root'></div> in index.html.");
}

// Start performance monitoring (optional)
reportWebVitals();
